export default __webpack_public_path__ + "static/bagel-9604c1b349d9019bfc9385e23f2cad83.png";